import { PX_PER_INCH } from "./constants";
import { isVisible } from "~/jose_modern/utils";

export const pxToInches = (val) => val / PX_PER_INCH;

export const isHidden = (el) => !isVisible(el);

/* Set element width and max-width in pixels */
export const forceElementWidth = (element, widthPx) => {
  element.style.width = `${widthPx}px`;
  element.style.maxWidth = element.style.width;
};

/**
 * Style the element as off-screen and append it to body.
 * (Potentially also add to on-screen debug area.)
 */
export const appendElementOffscreen = ({ element, debugElementId } = {}) => {
  if (debugElementId) {
    try {
      debugDisplaySimulatedElement({ element, debugElementId });
    } catch {
      // Do nothing
    }
  }

  element.style.position = "absolute";
  element.style.left = "-9999px";
  element.style.visibility = "hidden";
  document.body.appendChild(element);

  return element;
};

/**
 * We have to add some 'simulated' elements off-screen to measure them.
 * If RAILS_ENV=development, and window.DEBUG is enabled, we'll display them at the end of the page;
 * this is just for manually spot-checking stuff.
 */
export const debugDisplaySimulatedElement = ({ element, debugElementId }) => {
  if (!window?.DEBUG) return;

  const debugElement = document.getElementById(debugElementId);
  if (!debugElement) return;

  const el = element.cloneNode(true);

  debugElement.style.outline = "1px dotted red";
  debugElement.style.opacity = "100%"; // To undo debugDimSimulatedElement

  debugElement.innerHTML = "";
  debugElement.appendChild(el);
};

/**
 * Dim the debug-clone of a simulated element, i.e. to indicate it's hidden and excluded from dimensions measurement.
 */
export const debugDimSimulatedElement = (debugElementId) => {
  if (!window?.DEBUG) return;

  const debugElement = document.getElementById(debugElementId);
  if (!debugElement) return;

  debugElement.style.opacity = "15%";
  debugElement.style.outline = "1px dotted blue";
};

/** debugLog will only log if window.DEBUG is truthy.*/
export const debugLog = (...args) => {
  if (!window?.DEBUG) return;
  console.debug(...args);
};

// Track if we've logged an error message about a selector (so that we don't blow up Sentry too badly,
// given that this could be called again for each adjustment including each pixel of slider width adjustment).
let hasLoggedElementNotFound = {};

/** Get a single element. If not found, it will `console.error` (only once per distinct selector) */
export const getElement = (selector) => {
  const el = document.querySelector(selector);
  if (!el && !hasLoggedElementNotFound[selector]) {
    console.error(`[getElement] CODE DRIFT? Could not find element for selector: ${selector}`);
    hasLoggedElementNotFound[selector] = true;
  }
  return el;
};

/** Get 1+ elements. If none are found, it will `console.error` (only once per distinct selector) */
export function getElements(selector) {
  const el = document.querySelectorAll(selector);
  if (!el.length && !hasLoggedElementNotFound[selector]) {
    console.error(`[getElements] CODE DRIFT? Could not find elements for selector: ${selector}`);
    hasLoggedElementNotFound[selector] = true;
  }
  return el;
}
